import axios from 'axios'
import env from '../variables/EndpointEnvironment'

const RateExchangeAPI = () => {
  return axios.get(`${env.HOST}/rateExchange`, {
    headers: {
      'Content-Language': localStorage.getItem('i18nextLng'),
    },
  })
}

export default RateExchangeAPI
